import { makeEntityScaffold } from '@classpass/saga-tools';
import { transformKeysToCamelCase, trimTimezone } from 'helpers/core';
import { format, parse } from 'date-fns';

import { FULL_ISO_DATE_FORMAT } from 'constants/logic';
import URLS from 'constants/urls';
import { VENUE_FEATURE_PROBE_HTTP_CONFIG } from 'helpers/session-auth-http';

const trimTimezonesFromPayload = ({ startDate, recurrenceEndDate, ...rest }) => {
  const trimmedStartDate = trimTimezone(startDate);
  return {
    ...rest,
    startDate: trimmedStartDate,
    recurrenceEndDate: trimTimezone(recurrenceEndDate),
    startTime: format(parse(trimmedStartDate, FULL_ISO_DATE_FORMAT, new Date()), 'HH:mm'),
  };
};

// We need to transform schedule data to conform with data model we're using in create/edit forms.
export const transformScheduleData = schedule => {
  const { startDate, recurring, recurrence, recurrenceEndDate, ...restSchedule } = schedule;
  const transformedRecurrenceDays = {};
  let transformedSingleDayExceptions = [];

  if (recurring && recurrence) {
    recurrence.days.forEach(day => {
      transformedRecurrenceDays[day] = true;
    });

    if (recurrence.exclude) {
      transformedSingleDayExceptions = recurrence.exclude.map(day =>
        format(parse(day, 'yyyy-MM-dd', new Date()), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
      );
    }
  }

  return {
    ...restSchedule,
    isNoEndDate: !recurrenceEndDate,
    scheduleType: recurring ? 'recurring' : 'one-time',
    startDate,
    recurrence: transformedRecurrenceDays,
    recurrenceEndDate: recurrenceEndDate || new Date().toISOString(),
    singleDayExceptions: transformedSingleDayExceptions,
  };
};

const handler = ({ httpClient }, venueId, id) => {
  const url = URLS.msSchedules.get(venueId, id);
  return httpClient
    .get(url, VENUE_FEATURE_PROBE_HTTP_CONFIG)
    .then(({ data }) => transformKeysToCamelCase(data))
    .then(transformScheduleData)
    .then(trimTimezonesFromPayload);
};

export default makeEntityScaffold('SAGA.API.FETCH_SCHEDULE', handler);
